module.exports = __webpack_public_path__ + "static/media/image.cb313b7f.png";